import { Component, computed, DestroyRef, inject, signal, WritableSignal } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { SvgIconComponent } from 'component-library';
import { AuthService } from 'shared';
import { BreadcrumbService } from '../services/breadcrumb.service';
import { filter } from "rxjs";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-layout',
  imports: [RouterOutlet, RouterLink, RouterLinkActive, SvgIconComponent],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  standalone: true,
})
export class LayoutComponent {
  breadcrumbs = this.breadcrumbService.breadcrumbs;
  protected currentUrl: WritableSignal<string> = signal('');
  private readonly destroyRef = inject(DestroyRef);

  protected displayFullWidth = computed(() => this.currentUrl().includes('energieprofiel') || this.currentUrl().includes('vermogensvraag'));

  constructor(
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
  ) {
    // Watches router, in some routes content container should be full width.
    this.router.events
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl.set(event.urlAfterRedirects.toLowerCase());
      });
  }

  public logout(): void {
    this.authService.logout();
  }
}
